import React, { useState } from "react";

const faqData = [
    {
        pregunta: "¿Qué tipo de servicio ofrece Equipo MAG?",
        respuesta:
            "Ofrecemos un servicio de asesoramiento nutricional profesional, centrado en la reeducación alimentaria y la adquisición de hábitos saludables. Nuestros planes están diseñados para adaptarse a tu estilo de vida, sin exclusiones drásticas ni productos milagro.",
    },
    {
        pregunta: "¿Qué tipo de alimentos incluye la dieta?",
        respuesta: "¡Todos los grupos alimenticios! Trabajamos con una alimentación variada, equilibrada y personalizada. No eliminamos ningún macronutriente (carbohidratos, proteínas o grasas) salvo en casos médicos concretos. El objetivo es que aprendas a comer bien de forma sostenible en el tiempo, sin pasar hambre ni tener sensación de estar 'a dieta'. Incluirás frutas, verduras, legumbres, carnes, pescados, huevos, lácteos, cereales, frutos secos, etc., según tus necesidades y preferencias.",
    },
    {
        pregunta: "¿Cuál es el coste de las consultas?",
        respuesta: "El valor de la primera consulta es de 50€ y el de cada consulta de seguimiento es de 15€. Esta información es relevante a la hora de calcular cualquier posible devolución, ya que los importes se basan en estas tarifas."
    },
    {
        pregunta: "¿Tengo que comprar productos especiales o sustitutivos?",
        respuesta:
            "No. Nuestro método se basa únicamente en comida real. No vendemos ni recomendamos batidos, suplementos, pastillas o sustitutivos.",
    },
    {
        pregunta: "¿Es apto para personas con patologías?",
        respuesta:
            "Sí. Nuestros profesionales están capacitados para adaptar el plan a patologías como diabetes, colesterol alto, hipertensión, problemas digestivos, etc. En casos específicos, colaboramos con psicólogos y otros profesionales sanitarios para un enfoque integral.",
    },
    {
        pregunta: "¿En qué consiste la primera consulta?",
        respuesta:
            "Es una evaluación donde recogemos datos sobre tu salud, hábitos y objetivos. Te explicamos el funcionamiento y resolvemos tus dudas.",
    },
    {
        pregunta: "¿Cuánto duran las consultas?",
        respuesta:
            "La primera consulta dura 20 minutos. Las de seguimiento, 10 minutos.",
    },
    {
        pregunta: "¿Cada cuánto tiempo son las consultas?",
        respuesta:
            "Las consultas son semanales, como parte del protocolo de seguimiento personalizado.",
    },
    {
        pregunta: "¿Cómo puedo pagar el servicio?",
        respuesta:
            "Puedes pagar en efectivo, por transferencia bancaria o mediante financiación con enlace Klarna.",
    },
    {
        pregunta: "¿Qué es un bono?",
        respuesta:
            "Un bono es un paquete de consultas con descuento. Existen diferentes opciones según la duración del tratamiento.",
    },
    {
        pregunta: "¿Puedo solicitar la devolución del bono?",
        respuesta:
            "Sí, siempre que el motivo esté justificado (enfermedad, traslado, etc.). La devolución se calcula proporcionalmente a las sesiones disfrutadas.",
    },
    {
        pregunta: "¿Cómo sabré si estoy progresando?",
        respuesta:
            "Cada semana se revisan tus avances con una báscula homologada y se ajustan las pautas. También realizamos fotos del antes y después si lo autorizas.",
    },
    {
        pregunta: "¿Y si no pierdo peso?",
        respuesta:
            "El plan se ajusta a tu evolución. También trabajamos el aspecto emocional para ayudarte a mantener la motivación.",
    },
    {
        pregunta: "¿Dónde se realizan las consultas?",
        respuesta:
            "En centros colaboradores distribuidos por varias ciudades. Al reservar, te indicaremos el centro más cercano.",
    },
    {
        pregunta: "¿Puedo compartir mi experiencia en redes sociales?",
        respuesta:
            "Sí, y nos encantará que lo hagas. Solo compartimos fotos de pacientes con su consentimiento.",
    }
];

const FaqSection = () => {
    const [activeIndex, setActiveIndex] = useState(null);

    const handleToggle = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <section className="prt-row faq-service clearfix">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12 m-auto">
                        <div className="section-title title-style-center_text">
                            <div className="title-header">
                                <h2 className="title">Obtén tu respuesta aquí</h2>
                            </div>
                            <div className="desc">
                                <p>
                                    A continuación, encontrarás respuestas a algunas de las
                                    preguntas más frecuentes.
                                    <br />
                                    Constantemente añadimos más preguntas a esta página.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="accordion style2 mt-20">
                            {faqData.map((item, index) => (
                                <div
                                    key={index}
                                    className={`toggle prt-toggle_style_classic prt-control-right-true ${activeIndex === index ? "active" : ""
                                        }`}
                                >
                                    <div
                                        className="toggle-title"
                                        onClick={() => handleToggle(index)}
                                    >
                                        <a
                                            href={"/faq#" + index}
                                            className={activeIndex === index ? "active" : ""}
                                        >
                                            {item.pregunta}
                                        </a>
                                    </div>
                                    <div
                                        className="toggle-content"
                                        style={{
                                            display: activeIndex === index ? "block" : "none",
                                        }}
                                    >
                                        <p>{item.respuesta}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FaqSection;
